//formik
import { FieldArray, useFormikContext } from "formik";

//mui
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { DialogTitle } from "@mui/material";

//mui icon
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


//tranlsate
import { useTranslation } from "react-i18next";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface Props {
  selectedCar?: any;
  deleteImageIds: number[];
  setDeleteImageIds: React.Dispatch<React.SetStateAction<number[]>>;
  imagePreviews: (string | null)[];
  setImagePreviews: React.Dispatch<React.SetStateAction<(string | null)[]>>;
  storageURL?: string;
}

const AddImagesWithTitle = (
  { selectedCar, deleteImageIds, setDeleteImageIds, imagePreviews, setImagePreviews, storageURL }: Props
) => {
    const { values, setFieldValue, errors, touched } = useFormikContext<any>();
    const { t } = useTranslation();
  return (
    <div className="max-h-[400px] overflow-auto">
        <DialogTitle className='!px-0'>
            <p>{t("car_photos")}</p>
        </DialogTitle>
        <FieldArray name="images">
        {({ unshift, remove }) => (
            <div className="mt-5 space-y-4">
            <Button
                className='!bg-paretnerColor !text-white !text-[11px] w-fit !capitalize'
                onClick={() => {

                unshift({ file: null, title: "" });
                setImagePreviews((prev) => [null, ...prev]);
                }}
            >
               {t("add_image")}
            </Button>
            {values.images.map((img: any, index: number) => {
                return (
                    <div key={index} className="border p-3 rounded-lg space-y-2 relative">   
                        <div
                            color="error"
                            className='w-fit px-2 py-1 rounded-lg !bg-red-500 !text-white cursor-pointer mb-2'
                            onClick={() => {
                                if(selectedCar) {
                                    const matchedImage = selectedCar.primary_images.find((img1: any) => img1.id === img.id
                                    );
                                    if (matchedImage) {
                                        setDeleteImageIds((prev) => [...prev, matchedImage.id]);
                                    }
                                }
                                remove(index);
                                setImagePreviews((prev) => prev.filter((_, i) => i !== index));
                            }}
                        >
                        <DeleteOutlineIcon/>
                        </div>
                        <TextField
                            fullWidth
                            label={t("image_title")}
                            value={img.title}
                            onChange={(e) =>
                                setFieldValue(`images.${index}.title`, e.target.value)
                            }
                            error={
                                Boolean(
                                    (touched.images as any)?.[index]?.title &&
                                    (errors.images as any)?.[index]?.title
                                )
                            }                                
                            helperText={
                                (touched.images as any)?.[index]?.title &&
                                (errors.images as any)?.[index]?.title
                            }
                            />
                        <div>
                            <Button component="label" startIcon={<CloudUploadIcon />}>
                            {t("choose_image")}
                                <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        setFieldValue(`images.${index}.file`, file);
                                        setImagePreviews((prev) => {
                                        const newPreviews = [...prev];
                                        newPreviews[index] = URL.createObjectURL(file);
                                        return newPreviews;
                                        });
                                    }
                                }}
                                />
                            </Button>
                            {(touched.images as any)?.[index]?.file && (touched.images as any)?.[index]?.file && (
                                <p className="text-red-500 text-xs mt-1">
                                {(errors.images as any)?.[index]?.file}
                                </p>
                            )}
                            {
                            imagePreviews[index]
                            ? (
                                <img
                                src={imagePreviews[index]}
                                className="w-28 h-28 object-cover rounded"
                                alt="test1"
                                />
                            )
                            :
                            selectedCar
                                ?
                                values.images[index].file === null
                                    ? null
                                    :
                                    selectedCar?.primary_images.map((element:any, index: number) => {
                                        if(values.images[index].id === element.id) {
                                            return (
                                                <div key={element.id}>
                                                    <img
                                                    key={element.id}
                                                    src={`${storageURL}/${element.url}`}
                                                    className="w-40 h-28 object-cover rounded"
                                                    alt="test3"
                                                    />
                                                </div>
                                            )
                                        }
                                        else {
                                            return null ;                                                  
                                        }
                                    })
                                :null
                            }
                        </div>
                    </div>
                )
            })}
            </div>
        )}
        </FieldArray>
        {touched.images && typeof errors.images === "string" && (
        <p className="text-red-500 text-xs mt-2">
            {errors.images}
        </p>
        )}
    </div>
  )
}

export default AddImagesWithTitle